import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchWithAuth } from '../../services/api';

const AdminContactMessages = () => {
  const navigate = useNavigate();
  const { lang } = useParams();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadMessages = useCallback(async () => {
    const token = localStorage.getItem('jwtToken');
    if (!token || localStorage.getItem('userRole') !== 'ADMIN') {
      navigate(`/${lang || 'mk'}/`);
      return;
    }

    try {
      setLoading(true);
      const data = await fetchWithAuth('/admin/contact-messages');
      setMessages(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      console.error('Error fetching contact messages:', err);
      setError('Не може да се вчитаат контакт-пораките.');
    } finally {
      setLoading(false);
    }
  }, [lang, navigate]);

  useEffect(() => { loadMessages(); }, [loadMessages]);

  const formatDate = (value) => value ? new Date(value).toLocaleString('mk-MK', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
  }) : '—';

  if (loading) return <div className="p-8 text-center text-gray-600">Се вчитуваат пораки…</div>;
  if (error) return <div className="p-8 text-center text-red-700">{error}</div>;

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Контакт-пораки</h1>
            <p className="mt-1 text-gray-600">Вкупно: {messages.length}</p>
          </div>
          <button onClick={loadMessages} className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700">
            Освежи
          </button>
        </div>

        {messages.length === 0 ? (
          <div className="rounded-xl bg-white p-8 text-center shadow text-gray-600">Сè уште нема испратени пораки.</div>
        ) : (
          <div className="space-y-5">
            {messages.map((message) => (
              <article key={message.id} className="rounded-xl bg-white p-6 shadow">
                <div className="flex flex-wrap items-start justify-between gap-3 border-b border-gray-100 pb-4">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">{message.fullName}</h2>
                    <a href={`mailto:${message.email}`} className="text-indigo-700 hover:underline">{message.email}</a>
                  </div>
                  <div className="text-right text-sm text-gray-500">
                    <div>{formatDate(message.createdAt)}</div>
                    <div>IP: {message.ipAddress || '—'}</div>
                  </div>
                </div>
                <div className="mt-4">
                  <h3 className="font-medium text-gray-800">{message.subject || 'Без наслов'}</h3>
                  <p className="mt-2 whitespace-pre-wrap text-gray-700">{message.message}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContactMessages;
